"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rebuildJrn = exports.mapJrn = void 0;
/**
 * @description map jrn string to JrnScheme
 *
 * @export
 * @param {JRN} jrn
 * @returns {JrnScheme}
 */
function mapJrn(jrn) {
    var _a = __read(jrn.split(':')), scheme = _a[0], service = _a[1], location = _a[2], landlord = _a[3], account = _a[4], resource = _a.slice(5);
    return {
        scheme: scheme,
        service: service,
        location: location,
        landlord: landlord,
        account: account,
        resource: resource
    };
}
exports.mapJrn = mapJrn;
/**
 * @description rebuild jrn string from JrnScheme
 *
 * @export
 * @param {JrnScheme} jrnScheme
 * @returns {JRN}
 */
function rebuildJrn(jrnScheme) {
    var scheme = jrnScheme.scheme, service = jrnScheme.service, location = jrnScheme.location, landlord = jrnScheme.landlord, account = jrnScheme.account, resource = jrnScheme.resource;
    var resourceValue = resource ? resource.join(':') : '';
    return [
        scheme,
        service,
        location,
        landlord,
        account,
        resourceValue
    ]
        .join(':');
}
exports.rebuildJrn = rebuildJrn;
//# sourceMappingURL=jrn.js.map